
  import { Vue, Component, Prop } from "vue-property-decorator";
  import RouteParams from "@/entities/RouteParams";

  @Component
  export default class CardTitleContainer extends Vue {
    @Prop({ type: Object, default: undefined }) readonly routeParams!: RouteParams<{ id: string }>;
    @Prop({ type: String, default: undefined }) readonly title!: string;
  }
